import {memo, PropTypes, propTypesExact, ShapeComponent, shapeComponent, Text, useI18n} from "shared/base"
import React, {useMemo} from "react"
import {Subscription} from "models"
import {View} from "react-native"

export default memo(shapeComponent(class SchoolClassesCardSubscriptionBadge extends ShapeComponent {
  static defaultProps = {
    subscription: null
  }

  static propTypes = propTypesExact({
    subscription: PropTypes.instanceOf(Subscription)
  })

  setup() {
    const {t} = useI18n({namespace: "js.components.school_classes.card"})

    this.t = t
  }

  render() {
    const {t} = this.tt
    const {subscription} = this.props
    const plan = subscription?.plan()

    const dataSet = useMemo(() => {
      const dataSet = {class: "subscription-badge"}

      if (subscription) {
        dataSet.subscriptionType = plan.identifier()
      } else {
        dataSet.subscriptionType = "free"
      }

      return dataSet
    }, [subscription])

    const style = useMemo(() => {
      const style = {
        marginRight: 6,
        paddingHorizontal: 6,
        paddingVertical: 1,
        borderRadius: 22
      }

      if (subscription) {
        style.backgroundColor = "#5253ff"
        style.border = "1px solid #5253ff"
      } else {
        style.backgroundColor = "#fff"
        style.border = "1px solid #5253ff"
      }

      return style
    }, [subscription])

    const textStyle = useMemo(() => {
      const textStyle = {fontSize: 12}

      if (subscription) textStyle.color = "#fff"

      return textStyle
    }, [subscription])

    return (
      <View dataSet={dataSet} style={style}>
        <Text style={textStyle}>
          {plan?.name()}
          {!subscription && t(".basic")}
        </Text>
      </View>
    )
  }
}))
